export default __webpack_public_path__ + "static/media/1.23eb5e54.jpg";